// extracted by css-extract-rspack-plugin
var _1 = "T52dKgOs5cKSvwjZ";
var _2 = "vIXsbD40LjsLecnQ";
export { _1 as "overlayStyle", _2 as "overlayStyleLight" }
